import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React, { useRef, useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import { getFinanciacionType } from '../helpers/ofertas-helper';
import { Oferta } from '../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../tracking/use-tracking-manager';

export const RedirectCTAs = ({
	oferta,
	copy,
	isMobile,
	emphasis,
	trackingRef,
}: {
	oferta: Oferta;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	trackingRef?: string;
}) => {
	const { featureAppService } = React.useContext(OfertasContext);
	const [showOneFormCallMe, setShowOneFormCallMe] = useState<boolean>(false);
	const [showOneForm, setShowOneForm] = useState<boolean>(false);

	const featureAppRef = useRef(null);
	const marketingCodeConfigRef = useRef(null); //Esto tiene que ver con tracking

	const trackingManager = useTrackingManager();

	const handleOnClick = (copy: string) => {
		setShowOneForm(true);

		trackingManager.trackOfertasButtonClick(
			copy,
			{ contentId: trackingRef ? `${copy} - ${trackingRef}` : copy },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.motorizacionCode?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: getFinanciacionType(oferta),
				PriceRateTotal: oferta?.cuota ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: oferta?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);
	};

	const renderOneForm = (oferta: Oferta) => {
		if (showOneForm) {
			const featureApp =
				featureAppService.featureAppConfigurations['es-oneform-lead-embedded'];
			featureAppRef.current = featureApp;
		} else if (showOneFormCallMe) {
			const featureApp =
				featureAppService.featureAppConfigurations[
					'es-oneform-callme-embedded'
				];
			featureAppRef.current = featureApp;
		}

		return (
			<>
				<FeatureAppLoader
					{...featureAppRef.current}
					// src="http://localhost:3001/vw-oneform-feature-app.umd.js"
					featureAppId={`${featureAppRef.current.name}:oneform`}
					done={() => {
						setShowOneForm(false);
						setShowOneFormCallMe(false);
					}}
					beforeCreate={(env) => {
						if (env.featureServices['fa-content-service']) {
							env.featureServices['fa-content-service'].content = {
								featureApp: 'es-ofertas',
								oferta: oferta,
							};
						}
						if (env.featureServices['api-key-provider']) {
							env.featureServices['api-key-provider'].apiKey =
								featureAppRef.current.apiKey;
						}
						if (env.featureServices.tracking) {
							env.featureServices.tracking.contextualEventData = {
								event: {
									environment: {
										featureAppId: featureAppRef.current.trackingId,
									},
								},
							};
						}
					}}
				/>
			</>
		);
	};

	const RenderOneFormCTA = (): React.ReactElement => {
		return (
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={() => handleOnClick(copy)}
			>
				{copy}
			</CTA>
		);
	};

	return (
		<>
			{RenderOneFormCTA()}

			{showOneForm ? renderOneForm(oferta) : null}
		</>
	);
};
